// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.dc-locked {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 72px 32px 88px;
  min-height: 360px;
  width: 100%;
  background: linear-gradient(160deg, #fafafa 0%, #fff5f5 100%);
}
.dc-locked__icon-wrap {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #fff;
  border: none;
  box-shadow: 0 4px 20px rgba(198, 40, 40, 0.15), 0 1px 4px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}
.dc-locked__icon {
  font-size: 30px;
  color: #e53935;
}
.dc-locked__title {
  font-size: 24px;
  font-weight: 700;
  color: #212121;
  margin: 0 0 16px;
  max-width: 480px;
  line-height: 1.3;
}
.dc-locked__badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 20px;
  margin-bottom: 16px;
}
.dc-locked__badge--expired {
  background: linear-gradient(135deg, #e53935, #c62828);
  color: #fff;
  box-shadow: 0 3px 10px rgba(198, 40, 40, 0.35);
}
.dc-locked__badge--upcoming {
  background: linear-gradient(135deg, #1e88e5, #1565c0);
  color: #fff;
  box-shadow: 0 3px 10px rgba(21, 101, 192, 0.35);
}
.dc-locked__msg {
  font-size: 14px;
  color: #757575;
  margin: 0;
  max-width: 360px;
  line-height: 1.7;
}
.dc-locked__msg strong {
  color: #424242;
  font-weight: 600;
}

.media-content {
  position: relative;
}

.media-content {
  position: relative;
}
.media-content .product__heading--activity {
  margin-bottom: 20px;
}
.media-content .product__heading--activity small {
  font-size: 65%;
  font-weight: 400;
}

.fixed-loader {
  width: 100%;
  height: 100%;
  text-align: center;
}
.fixed-loader i {
  font-size: 8em !important;
}

.iguide-download {
  width: 100%;
}

.mr-top-15 {
  margin-top: 10px;
}

/* iCheck plugin Square skin, green
----------------------------------- */
::ng-deep .ibox-content {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  /* HiDPI support */
}
::ng-deep .ibox-content--bdr {
  border: 0;
  padding-inline: 0;
}
::ng-deep .ibox-content .icheckbox_square-green,
::ng-deep .ibox-content .iradio_square-green {
  display: inline-block;
  *display: inline;
  vertical-align: middle;
  margin: 0;
  padding: 0;
  width: 22px;
  height: 22px;
  background: url("https://assets.foursightonline.com/app/images/green.png") no-repeat;
  border: none;
  cursor: pointer;
}
::ng-deep .ibox-content .icheckbox_square-green {
  background-position: 0 0;
}
::ng-deep .ibox-content .icheckbox_square-green.hover {
  background-position: -24px 0;
}
::ng-deep .ibox-content .icheckbox_square-green.checked {
  background-position: -48px 0;
}
::ng-deep .ibox-content .icheckbox_square-green.disabled {
  background-position: -72px 0;
  cursor: default;
}
::ng-deep .ibox-content .icheckbox_square-green.checked.disabled {
  background-position: -96px 0;
}
::ng-deep .ibox-content .iradio_square-green {
  background-position: -120px 0;
}
::ng-deep .ibox-content .iradio_square-green.hover {
  background-position: -144px 0;
}
::ng-deep .ibox-content .iradio_square-green.checked {
  background-position: -168px 0;
}
::ng-deep .ibox-content .iradio_square-green.disabled {
  background-position: -192px 0;
  cursor: default;
}
::ng-deep .ibox-content .iradio_square-green.checked.disabled {
  background-position: -216px 0;
}
@media (min-resolution: 120dpi) {
  ::ng-deep .ibox-content .icheckbox_square-green,
  ::ng-deep .ibox-content .iradio_square-green {
    background-image: url("https://assets.foursightonline.com/app/images/green@2x.png");
    background-size: 240px 24px;
  }
}

.package-form {
  display: inline-block;
  width: 50%;
  padding-right: 40px;
}
.package-form label,
.package-form select {
  width: 100%;
}
.package-form label {
  line-height: 2em;
  padding: 0.75rem 0.75rem 0.75rem 0 !important;
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
.package-form select {
  border: 1px solid #ddd;
  padding: 10px !important;
  height: 40px;
  background: #F8F8F8;
  color: #636363;
  font-family: "Museo-300";
  margin-bottom: 10px;
}
.package-form select:focus {
  outline: none;
}

.iguide-download {
  width: 100%;
}
.iguide-download .warning {
  padding-top: 10px;
  display: block;
}

.mr-top-15 {
  margin-top: 10px;
}

::ng-deepul.inputs-list {
  padding-left: 0;
  list-style: none;
}

::ng-deepul.inputs-list input {
  margin-right: 10px;
}

::ng-deep#hubspotForm {
  margin-bottom: 10px;
}

::ng-deep.hs-error-msgs {
  display: none !important;
}

.mark-checkbox {
  margin-right: 5px;
}

.ibox--bdr {
  border: 0 !important;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: block;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.single-box-nav .text-center span.scroll-btn a:after {
  width: unset;
}

.img--xtrahyt {
  min-height: 420px;
}

.image-imitation {
  --flexGap: 45px;
}
.image-imitation .audio-card {
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-imitation .audio-card__player audio {
  height: var(--flexGap);
}
.image-imitation .audio-card__vol {
  width: var(--flexGap);
  height: var(--flexGap);
  background-color: #eee;
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding-inline: 10px;
  margin-left: 10px;
}
.image-imitation .audio-card__ftrtextneg {
  border-radius: 30px;
  outline: none;
  box-shadow: none;
  height: 45px;
  margin-left: 10px;
  width: 100px;
  border: 0px;
}
.image-imitation .audio-card__ftrtextneg .fa {
  margin-right: 8px;
}
.image-imitation .audio-card__ftrauth {
  height: 45px;
  overflow: hidden;
  width: 45px;
  margin-right: 10px;
}
.image-imitation .audio-card__ftrauth img {
  border-radius: 50%;
}

@media only screen and (max-width: 991px) {
  ::ng-deep .coach-slider .page-heading {
    margin-bottom: 0 !important;
  }
}
::ng-deep .coach-slider .ibox {
  position: relative;
}
::ng-deep .coach-slider .ibox__close {
  position: absolute;
  right: 11px;
  z-index: 9;
  top: 20px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .coach-slider .ibox__close {
    right: 35px;
  }
}
::ng-deep .coach-slider .ibox__close a {
  border-radius: 50%;
  border: 1px solid #CFDBE2;
  padding: 4px 8px;
}
@media only screen and (max-width: 991px) and (orientation: landscape) {
  ::ng-deep .coach-slider .ibox-footer {
    display: flex;
    margin: 0 auto;
  }
  ::ng-deep .coach-slider .ibox-footer .next-link {
    padding-right: 60px;
  }
}
::ng-deep .coach-slider .ibox-footer .single-box-nav {
  display: flex;
  justify-content: space-between;
}
::ng-deep .coach-slider .ibox-footer .single-box-nav a {
  font-size: 14px !important;
}
::ng-deep .coach-slider .ibox-footer .col-xs-3 {
  width: 50%;
  padding-left: 5px;
  padding-right: 5px;
}
::ng-deep .coach-slider .ibox-content .single-card-link {
  padding: 10px 0;
}
::ng-deep .coach-slider .ibox-content hr {
  display: none;
}
::ng-deep .coach-slider .ibox-content br {
  display: none;
}
::ng-deep .coach-slider .ibox-content .card-description {
  padding-bottom: 25px;
}
::ng-deep .coach-slider .ibox-content .card-description p {
  margin: 0;
  font-size: 14px;
  color: #676a6c;
}
::ng-deep .coach-slider-footer {
  padding: 10px 0px;
}
::ng-deep .coach-slider-footer .single-box-nav {
  display: flex;
  justify-content: space-between;
}
::ng-deep .coach-slider-footer .single-box-nav a {
  font-size: 14px !important;
}
::ng-deep .coach-slider-footer .image-imitation {
  box-shadow: none;
}
::ng-deep .coach-slider-footer .image-imitation .audio-card audio {
  max-width: 100%;
}
@media only screen and (max-width: 480px) {
  ::ng-deep .coach-slider-footer .image-imitation .audio-card {
    transform: scale(0.8);
  }
  ::ng-deep .coach-slider-footer .image-imitation .audio-card__vol, ::ng-deep .coach-slider-footer .image-imitation .audio-card__ftrtextneg {
    display: none;
  }
  ::ng-deep .coach-slider-footer .image-imitation .audio-card audio::-webkit-media-controls-volume-slider,
  ::ng-deep .coach-slider-footer .image-imitation .audio-card audio::-webkit-media-controls-mute-button,
  ::ng-deep .coach-slider-footer .image-imitation .audio-card audio::-webkit-media-controls-volume-slider-container {
    display: block;
  }
}
::ng-deep .coach-slider-footer .image-imitation .audio-card__ftrauth {
  height: 36px;
  width: 36px;
  margin-right: 5px;
}
::ng-deep .coach-slider-footer .image-imitation .audio-card__vol {
  margin-left: 10px;
  height: 26px;
  width: 26px;
}
::ng-deep .coach-slider-footer .image-imitation .audio-card__ftrtextneg {
  width: 55px;
  height: 26px;
}
::ng-deep .coach-slider-footer .image-imitation .audio-card__ftrtextneg span {
  font-size: 10px;
}
::ng-deep .coach-slider-footer .image-imitation .audio-card__ftrtextneg span i {
  margin-right: 4px;
}
::ng-deep .coach-slider-content .single-card-link {
  padding: 10px 0;
}
::ng-deep .coach-slider-content hr {
  display: none;
}
::ng-deep .coach-slider-content br {
  display: none;
}
::ng-deep .coach-slider-content .card-description {
  padding-bottom: 25px;
}
::ng-deep .coach-slider-content .card-description p {
  margin: 0;
  font-size: 14px;
  color: #676A6C;
}

.media-content__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
}
.media-content__audio {
  align-items: flex-start;
  min-height: auto;
  padding-bottom: 15px;
}
.media-content .image-imitation {
  box-shadow: none;
}
.media-content .image-imitation .audio-card audio {
  max-width: 100%;
}
@media only screen and (max-width: 480px) {
  .media-content .image-imitation .audio-card {
    transform: scale(0.8);
  }
  .media-content .image-imitation .audio-card__vol, .media-content .image-imitation .audio-card__ftrtextneg {
    display: none;
  }
  .media-content .image-imitation .audio-card audio::-webkit-media-controls-volume-slider,
  .media-content .image-imitation .audio-card audio::-webkit-media-controls-mute-button,
  .media-content .image-imitation .audio-card audio::-webkit-media-controls-volume-slider-container {
    display: block;
  }
}
.media-content .image-imitation .audio-card__ftrauth {
  height: 36px;
  width: 36px;
  margin-right: 5px;
}
.media-content .image-imitation .audio-card__vol {
  margin-left: 10px;
  height: 26px;
  width: 26px;
}
.media-content .image-imitation .audio-card__ftrtextneg {
  width: 55px;
  height: 26px;
}
.media-content .image-imitation .audio-card__ftrtextneg span {
  font-size: 10px;
}
.media-content .image-imitation .audio-card__ftrtextneg span i {
  margin-right: 4px;
}

.white-bg.page-heading.challenge-coach {
  margin-top: -20px;
  margin-bottom: 20px;
}
.white-bg.page-heading.challenge-coach .breadcrumb {
  font-size: 12px;
}
.white-bg.page-heading.challenge-coach .button-wrapper-flex-right {
  width: 10%;
}
.white-bg.page-heading.challenge-coach .col-lg-10 {
  width: 90%;
}

.dc-single__inner .ibox-content .media-content h2 small {
  font-size: 65%;
  line-height: 1;
  font-weight: 400;
}
.dc-single hr {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #eeeeee;
}

@media (max-width: 1440px) {
  .product-detail .ibox-content .f-flex .media-content {
    width: 50%;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  .product-detail .ibox-content .f-flex .media-content {
    width: 100%;
    padding-inline: 15px;
  }
}
@media (max-width: 1440px) {
  .product-detail .ibox-content .f-flex .media-content + .media-content {
    padding-right: 15px;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  .product-detail .ibox-footer .single-box-nav .text-left a:before {
    font-size: 20px;
    left: -24px;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  .product-detail .ibox-footer .single-box-nav .text-left {
    padding-left: 0;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  .product-detail .ibox-footer .single-box-nav .text-center span.scroll-btn a:after {
    height: 20px;
    bottom: -19px;
    width: 100% !important;
    border: none;
    background: #666;
    clip-path: polygon(102% 0%, -2% 0, 50% 100%);
    left: 0;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  .product-detail .ibox-footer .single-box-nav .text-right a:after {
    font-size: 20px;
    right: -24px;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  .product-detail .ibox-footer .single-box-nav .text-right {
    padding-right: 0;
  }
}

.mark-btn > div {
  border: 1px solid #e7eaec;
  border-bottom: 0;
  font-weight: 700;
}
.mark-btn > div input[type=checkbox] {
  height: auto;
  width: auto;
  opacity: 1;
  position: static !important;
  accent-color: green;
}
.mark-btn .dc-single .ibox-content .media-content .single-card-link,
.mark-btn .dc-single .media-content .single-card-link {
  font-family: "Museo-700", "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-size: 22px !important;
  line-height: 1.3 !important;
  color: #6d6e71 !important;
  margin: 0 0 14px !important;
  padding: 0 30px 0 0 !important;
  letter-spacing: -0.01em;
}
.mark-btn .dc-single .ibox-content .media-content .single-card-link .pull-right.grey-link,
.mark-btn .dc-single .media-content .single-card-link .pull-right.grey-link {
  font-size: 18px;
  color: #ccc;
  transition: color 0.15s ease;
}
.mark-btn .dc-single .ibox-content .media-content .single-card-link .pull-right.grey-link:hover,
.mark-btn .dc-single .media-content .single-card-link .pull-right.grey-link:hover {
  color: rgb(0, 173, 208);
}
.mark-btn .dc-single .ibox-content .media-content .m-t-md .product-main-price,
.mark-btn .dc-single .ibox-content .media-content .product-main-price,
.mark-btn .dc-single .media-content .m-t-md .product-main-price,
.mark-btn .dc-single .media-content .product-main-price {
  font-size: 13px !important;
  line-height: 1.6 !important;
  color: #676a6c !important;
  margin: 0 0 18px !important;
  padding: 12px 16px !important;
  background: #f7f8fa !important;
  border-left: 3px solid rgb(0, 173, 208) !important;
  border-radius: 4px !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-weight: 400 !important;
}
.mark-btn .dc-single .ibox-content .media-content .m-t-md .product-main-price small,
.mark-btn .dc-single .ibox-content .media-content .product-main-price small,
.mark-btn .dc-single .media-content .m-t-md .product-main-price small,
.mark-btn .dc-single .media-content .product-main-price small {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #676a6c !important;
  display: inline-block;
  line-height: 1.8;
}
.mark-btn .dc-single .ibox-content .media-content hr,
.mark-btn .dc-single .media-content hr {
  display: block !important;
  border: 0 !important;
  border-top: 1px solid #e7eaec !important;
  margin: 18px 0 !important;
}
.mark-btn .dc-single .ibox-content .media-content .card-description,
.mark-btn .dc-single .media-content .card-description {
  font-size: 14px !important;
  line-height: 1.65 !important;
  color: #676a6c !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  padding: 0 !important;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download,
.mark-btn .dc-single .ibox-content .media-content .package-form,
.mark-btn .dc-single .media-content .iguide-download,
.mark-btn .dc-single .media-content .package-form {
  margin-top: 18px;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download > span,
.mark-btn .dc-single .ibox-content .media-content .package-form > span,
.mark-btn .dc-single .media-content .iguide-download > span,
.mark-btn .dc-single .media-content .package-form > span {
  display: inline-block;
  font-size: 13px;
  color: #676a6c;
  margin-bottom: 10px;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .warning,
.mark-btn .dc-single .ibox-content .media-content .package-form .warning,
.mark-btn .dc-single .media-content .iguide-download .warning,
.mark-btn .dc-single .media-content .package-form .warning {
  font-size: 13px;
  color: rgb(245, 67, 89);
  margin: 8px 0;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .btn.btn-primary,
.mark-btn .dc-single .ibox-content .media-content .package-form .btn.btn-primary,
.mark-btn .dc-single .media-content .iguide-download .btn.btn-primary,
.mark-btn .dc-single .media-content .package-form .btn.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: "Museo-regular", "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  background-color: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
  color: #fff;
  border-radius: 6px;
  text-decoration: none;
  transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
  cursor: pointer;
  letter-spacing: 0.02em;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .btn.btn-primary:hover, .mark-btn .dc-single .ibox-content .media-content .iguide-download .btn.btn-primary:focus,
.mark-btn .dc-single .ibox-content .media-content .package-form .btn.btn-primary:hover,
.mark-btn .dc-single .ibox-content .media-content .package-form .btn.btn-primary:focus,
.mark-btn .dc-single .media-content .iguide-download .btn.btn-primary:hover,
.mark-btn .dc-single .media-content .iguide-download .btn.btn-primary:focus,
.mark-btn .dc-single .media-content .package-form .btn.btn-primary:hover,
.mark-btn .dc-single .media-content .package-form .btn.btn-primary:focus {
  background-color: #5ba523;
  border-color: #5ba523;
  color: #fff;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .btn.btn-primary:active,
.mark-btn .dc-single .ibox-content .media-content .package-form .btn.btn-primary:active,
.mark-btn .dc-single .media-content .iguide-download .btn.btn-primary:active,
.mark-btn .dc-single .media-content .package-form .btn.btn-primary:active {
  transform: translateY(1px);
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .btn.btn-primary::before,
.mark-btn .dc-single .ibox-content .media-content .package-form .btn.btn-primary::before,
.mark-btn .dc-single .media-content .iguide-download .btn.btn-primary::before,
.mark-btn .dc-single .media-content .package-form .btn.btn-primary::before {
  content: "\\f019";
  font-family: FontAwesome;
  font-size: 12px;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .f-btn,
.mark-btn .dc-single .ibox-content .media-content .package-form .f-btn,
.mark-btn .dc-single .media-content .iguide-download .f-btn,
.mark-btn .dc-single .media-content .package-form .f-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: "Museo-regular", "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  background-color: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
  color: #fff;
  border-radius: 6px;
  text-decoration: none;
  transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
  cursor: pointer;
  letter-spacing: 0.02em;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .f-btn:hover, .mark-btn .dc-single .ibox-content .media-content .iguide-download .f-btn:focus,
.mark-btn .dc-single .ibox-content .media-content .package-form .f-btn:hover,
.mark-btn .dc-single .ibox-content .media-content .package-form .f-btn:focus,
.mark-btn .dc-single .media-content .iguide-download .f-btn:hover,
.mark-btn .dc-single .media-content .iguide-download .f-btn:focus,
.mark-btn .dc-single .media-content .package-form .f-btn:hover,
.mark-btn .dc-single .media-content .package-form .f-btn:focus {
  background-color: #5ba523;
  border-color: #5ba523;
  color: #fff;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .f-btn:active,
.mark-btn .dc-single .ibox-content .media-content .package-form .f-btn:active,
.mark-btn .dc-single .media-content .iguide-download .f-btn:active,
.mark-btn .dc-single .media-content .package-form .f-btn:active {
  transform: translateY(1px);
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .f-btn::before,
.mark-btn .dc-single .ibox-content .media-content .package-form .f-btn::before,
.mark-btn .dc-single .media-content .iguide-download .f-btn::before,
.mark-btn .dc-single .media-content .package-form .f-btn::before {
  content: "\\f019";
  font-family: FontAwesome;
  font-size: 12px;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .f-btn + .f-btn, .mark-btn .dc-single .ibox-content .media-content .iguide-download .f-btn.f-m-top-15,
.mark-btn .dc-single .ibox-content .media-content .package-form .f-btn + .f-btn,
.mark-btn .dc-single .ibox-content .media-content .package-form .f-btn.f-m-top-15,
.mark-btn .dc-single .media-content .iguide-download .f-btn + .f-btn,
.mark-btn .dc-single .media-content .iguide-download .f-btn.f-m-top-15,
.mark-btn .dc-single .media-content .package-form .f-btn + .f-btn,
.mark-btn .dc-single .media-content .package-form .f-btn.f-m-top-15 {
  margin-top: 10px;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .assessment,
.mark-btn .dc-single .ibox-content .media-content .package-form .assessment,
.mark-btn .dc-single .media-content .iguide-download .assessment,
.mark-btn .dc-single .media-content .package-form .assessment {
  margin-bottom: 14px;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .assessment label,
.mark-btn .dc-single .ibox-content .media-content .package-form .assessment label,
.mark-btn .dc-single .media-content .iguide-download .assessment label,
.mark-btn .dc-single .media-content .package-form .assessment label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6d6e71;
  margin-bottom: 6px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .assessment select,
.mark-btn .dc-single .ibox-content .media-content .package-form .assessment select,
.mark-btn .dc-single .media-content .iguide-download .assessment select,
.mark-btn .dc-single .media-content .package-form .assessment select {
  display: block;
  width: 100%;
  max-width: 320px;
  padding: 9px 36px 9px 12px;
  font-size: 14px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #6d6e71;
  background-color: #fff;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath fill='%236d6e71' d='M6 8.5L1.5 4h9z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .assessment select:hover,
.mark-btn .dc-single .ibox-content .media-content .package-form .assessment select:hover,
.mark-btn .dc-single .media-content .iguide-download .assessment select:hover,
.mark-btn .dc-single .media-content .package-form .assessment select:hover {
  border-color: #d0d6da;
}
.mark-btn .dc-single .ibox-content .media-content .iguide-download .assessment select:focus,
.mark-btn .dc-single .ibox-content .media-content .package-form .assessment select:focus,
.mark-btn .dc-single .media-content .iguide-download .assessment select:focus,
.mark-btn .dc-single .media-content .package-form .assessment select:focus {
  outline: none;
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.15);
}

:host ::ng-deep .dc-single .card-description p {
  margin: 0 0 14px !important;
  font-size: 14px !important;
  line-height: 1.65 !important;
  color: #676a6c !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}
:host ::ng-deep .dc-single .card-description p:last-child {
  margin-bottom: 0 !important;
}
:host ::ng-deep .dc-single .card-description p:empty,
:host ::ng-deep .dc-single .card-description p > br:only-child {
  display: none;
}
:host ::ng-deep .dc-single .card-description h1, :host ::ng-deep .dc-single .card-description h2, :host ::ng-deep .dc-single .card-description h3, :host ::ng-deep .dc-single .card-description h4, :host ::ng-deep .dc-single .card-description h5, :host ::ng-deep .dc-single .card-description h6 {
  font-family: "Museo-700", "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  color: #6d6e71 !important;
  margin: 22px 0 10px !important;
  line-height: 1.35 !important;
  font-weight: 700 !important;
}
:host ::ng-deep .dc-single .card-description h1 {
  font-size: 20px !important;
}
:host ::ng-deep .dc-single .card-description h2 {
  font-size: 18px !important;
}
:host ::ng-deep .dc-single .card-description h3 {
  font-size: 16px !important;
}
:host ::ng-deep .dc-single .card-description h4, :host ::ng-deep .dc-single .card-description h5, :host ::ng-deep .dc-single .card-description h6 {
  font-size: 14px !important;
}
:host ::ng-deep .dc-single .card-description a {
  color: rgb(0, 173, 208) !important;
  text-decoration: none !important;
  border-bottom: 1px solid rgba(0, 173, 208, 0.35);
  transition: border-color 0.15s ease, color 0.15s ease;
  font-weight: 500;
}
:host ::ng-deep .dc-single .card-description a:hover,
:host ::ng-deep .dc-single .card-description a:focus {
  color: #008ba7 !important;
  border-bottom-color: rgb(0, 173, 208);
}
:host ::ng-deep .dc-single .card-description a.btn,
:host ::ng-deep .dc-single .card-description a[class*=btn-],
:host ::ng-deep .dc-single .card-description button {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  padding: 10px 20px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  font-family: "Museo-regular", "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  background-color: rgb(105, 190, 40) !important;
  border: 1px solid rgb(105, 190, 40) !important;
  color: #fff !important;
  border-radius: 6px !important;
  text-decoration: none !important;
  letter-spacing: 0.02em;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  margin-top: 6px;
}
:host ::ng-deep .dc-single .card-description a.btn:hover, :host ::ng-deep .dc-single .card-description a.btn:focus,
:host ::ng-deep .dc-single .card-description a[class*=btn-]:hover,
:host ::ng-deep .dc-single .card-description a[class*=btn-]:focus,
:host ::ng-deep .dc-single .card-description button:hover,
:host ::ng-deep .dc-single .card-description button:focus {
  background-color: #5ba523 !important;
  border-color: #5ba523 !important;
  color: #fff !important;
}
:host ::ng-deep .dc-single .card-description strong, :host ::ng-deep .dc-single .card-description b {
  color: #6d6e71 !important;
  font-weight: 600 !important;
}
:host ::ng-deep .dc-single .card-description ul, :host ::ng-deep .dc-single .card-description ol {
  margin: 0 0 14px !important;
  padding-left: 22px !important;
}
:host ::ng-deep .dc-single .card-description ul li, :host ::ng-deep .dc-single .card-description ol li {
  margin-bottom: 6px;
  font-size: 14px !important;
  line-height: 1.65 !important;
  color: #676a6c !important;
}
:host ::ng-deep .dc-single .card-description ul li {
  list-style-type: disc !important;
}
:host ::ng-deep .dc-single .card-description ol li {
  list-style-type: decimal !important;
}
:host ::ng-deep .dc-single .card-description img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  margin: 10px 0;
}
:host ::ng-deep .dc-single .card-description blockquote {
  margin: 14px 0;
  padding: 10px 16px;
  border-left: 3px solid rgb(255, 121, 0);
  background: #fffaf4;
  color: #676a6c;
  font-style: italic;
  border-radius: 0 4px 4px 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/learner-maps/dynamic-learner-map/dynamic-card-single/dynamic-card-single.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA3YA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,6DAAA;AA8YF;AA5YE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,6EAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA8YJ;AA3YE;EACE,eAAA;EACA,cAAA;AA6YJ;AA1YE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA4YJ;AAzYE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AA2YJ;AAzYI;EACE,qDAAA;EACA,WAAA;EACA,8CAAA;AA2YN;AAxYI;EACE,qDAAA;EACA,WAAA;EACA,+CAAA;AA0YN;AAtYE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAwYJ;AAtYI;EACE,cAAA;EACA,gBAAA;AAwYN;;AAhYA;EACE,kBAAA;AAmYF;;AAhYA;EACE,kBAAA;AAmYF;AAhYI;EACE,mBAAA;AAkYN;AAhYM;EACE,cAAA;EACA,gBAAA;AAkYR;;AA5XA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA+XF;AA7XE;EACE,yBAAA;AA+XJ;;AA3XA;EACE,WAAA;AA8XF;;AA3XA;EACE,gBAAA;AA8XF;;AA3XA;qCAAA;AAGA;EACE,4BAAA;EACA,sBAAA;EACA,2BAAA;EA+DA,kBAAA;AA+TF;AA5XE;EACE,SAAA;EACA,iBAAA;AA8XJ;AA3XE;;EAEE,qBAAA;GA6XF,eA5XE;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oFAAA;EACA,YAAA;EACA,eAAA;AA6XJ;AA1XE;EACE,wBAAA;AA4XJ;AAzXE;EACE,4BAAA;AA2XJ;AAxXE;EACE,4BAAA;AA0XJ;AAvXE;EACE,4BAAA;EACA,eAAA;AAyXJ;AAtXE;EACE,4BAAA;AAwXJ;AArXE;EACE,6BAAA;AAuXJ;AApXE;EACE,6BAAA;AAsXJ;AAnXE;EACE,6BAAA;AAqXJ;AAlXE;EACE,6BAAA;EACA,eAAA;AAoXJ;AAjXE;EACE,6BAAA;AAmXJ;AA/WE;EAIE;;IAEE,mFAAA;IAEA,2BAAA;EA8WJ;AACF;;AA1WA;EACE,qBAAA;EACA,UAAA;EACA,mBAAA;AA6WF;AA3WE;;EAEE,WAAA;AA6WJ;AA1WE;EACE,gBAAA;EACA,6CAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA4WJ;AAzWE;EACE,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;AA2WJ;AAxWE;EACE,aAAA;AA0WJ;;AAtWA;EACE,WAAA;AAyWF;AAvWE;EACE,iBAAA;EACA,cAAA;AAyWJ;;AArWA;EACE,gBAAA;AAwWF;;AArWA;EACE,eAAA;EACA,gBAAA;AAwWF;;AArWA;EACE,kBAAA;AAwWF;;AArWA;EACE,mBAAA;AAwWF;;AArWA;EACE,wBAAA;AAwWF;;AArWA;EACE,iBAAA;AAwWF;;AApWE;EACE,oBAAA;AAuWJ;;AAnWA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,cAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAsWF;;AAnWA;EACE,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AAsWF;;AAnWA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAsWF;;AAlWA;EACE,mCAAA;EACA,UAAA;AAqWF;;AAlWA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAqWF;;AAlWA;EACE,mCAAA;EACA,mBAAA;EACA,UAAA;AAqWF;;AAlWA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAqWF;;AAlWA;EACE;IACE,UAAA;EAqWF;EAlWA;IACE,UAAA;EAoWF;EAjWA;IACE,UAAA;EAmWF;AACF;AA3VU;EACE,YAAA;AA6VZ;;AApVE;EACE,iBAAA;AAuVJ;;AAnVA;EACE,eAAA;AAsVF;AApVE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAsVJ;AAlVM;EACE,sBAAA;AAoVR;AAhVI;EACE,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;AAkVN;AA/UI;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AAiVN;AA/UM;EACE,iBAAA;AAiVR;AA7UI;EACE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AA+UN;AA7UM;EACE,kBAAA;AA+UR;;AAtUI;EADF;IAEI,2BAAA;EA0UJ;AACF;AAvUE;EACE,kBAAA;AAyUJ;AAvUI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AAyUN;AAvUM;EANF;IAOI,WAAA;EA0UN;AACF;AAxUM;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;AA0UR;AAnUM;EAHF;IAII,aAAA;IAEA,cAAA;EAqUN;EAnUM;IACE,mBAAA;EAqUR;AACF;AAlUM;EACE,aAAA;EACA,8BAAA;AAoUR;AAlUQ;EACE,0BAAA;AAoUV;AA/TM;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AAiUR;AA3TM;EACE,eAAA;AA6TR;AA1TM;EACE,aAAA;AA4TR;AAzTM;EACE,aAAA;AA2TR;AAxTM;EACE,oBAAA;AA0TR;AAxTQ;EACE,SAAA;EACA,eAAA;EACA,cDzdW;ACmxBrB;AAlTE;EACE,iBAAA;AAoTJ;AAlTI;EACE,aAAA;EACA,8BAAA;AAoTN;AAlTM;EACE,0BAAA;AAoTR;AA/SI;EACE,gBAAA;AAiTN;AA5SQ;EACE,eAAA;AA8SV;AA3SQ;EANF;IAOI,qBAAA;EA8SR;EA5SQ;IAEE,aAAA;EA6SV;EA1SQ;;;IAGE,cAAA;EA4SV;AACF;AAxSQ;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AA0SV;AAvSQ;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AAySV;AArSQ;EACE,WAAA;EACA,YAAA;AAuSV;AArSU;EACE,eAAA;AAuSZ;AArSY;EACE,iBAAA;AAuSd;AA5RI;EACE,eAAA;AA8RN;AA3RI;EACE,aAAA;AA6RN;AA1RI;EACE,aAAA;AA4RN;AAzRI;EACE,oBAAA;AA2RN;AAzRM;EACE,SAAA;EACA,eAAA;EACA,cAAA;AA2RR;;AAjRE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAoRJ;AAjRE;EACE,uBAAA;EACA,gBAAA;EACA,oBAAA;AAmRJ;AAhRE;EACE,gBAAA;AAkRJ;AA7QM;EACE,eAAA;AA+QR;AA5QM;EANF;IAOI,qBAAA;EA+QN;EA7QM;IAEE,aAAA;EA8QR;EA3QM;;;IAGE,cAAA;EA6QR;AACF;AAzQM;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AA2QR;AAxQM;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AA0QR;AAtQM;EACE,WAAA;EACA,YAAA;AAwQR;AAtQQ;EACE,eAAA;AAwQV;AAtQU;EACE,iBAAA;AAwQZ;;AA3PI;EACE,iBAAA;EACA,mBAAA;AA8PN;AA5PM;EACE,eAAA;AA8PR;AA3PM;EACE,UAAA;AA6PR;AA1PM;EACE,UAAA;AA4PR;;AA1OY;EACE,cAAA;EACA,cAAA;EACA,gBAAA;AA6Od;AArOE;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;AAuOJ;;AA5NQ;EADF;IAEI,UAAA;EAgOR;AACF;AA9NQ;EALF;IAOI,WAAA;IACA,oBAAA;EAgOR;AACF;AA7NU;EADF;IAEI,mBAAA;EAgOV;AACF;AAhNY;EAFF;IAII,eAAA;IACA,WAAA;EAkNZ;AACF;AA9MQ;EAdF;IAgBI,eAAA;EAgNR;AACF;AAnMgB;EAFF;IAII,YAAA;IACA,aAAA;IACA,sBAAA;IACA,YAAA;IACA,gBAAA;IACA,4CAAA;IACA,OAAA;EAqMhB;AACF;AAxLY;EAFF;IAII,eAAA;IACA,YAAA;EA0LZ;AACF;AAtLQ;EAdF;IAgBI,gBAAA;EAwLR;AACF;;AAjLE;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;AAoLJ;AAlLI;EACE,YAAA;EACA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,mBAAA;AAoLN;AAzKE;;EACE,gGAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,2BAAA;EACA,8BAAA;EACA,uBAAA;AA4KJ;AA1KI;;EACE,eAAA;EACA,WD5zBc;EC6zBd,4BAAA;AA6KN;AA3KM;;EACE,uBDr1BQ;ACmgChB;AAxKE;;;;EAEE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,8BAAA;EACA,kDAAA;EACA,6BAAA;EACA,mFAAA;EACA,2BAAA;AA4KJ;AA1KI;;;;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AA+KN;AA3KE;;EACE,yBAAA;EACA,oBAAA;EACA,wCAAA;EACA,yBAAA;AA8KJ;AA1KI;;EACE,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,mFAAA;EACA,qBAAA;AA6KN;AAzKI;;;;EAEE,gBAAA;AA6KN;AA3KM;;;;EACE,qBAAA;EACA,eAAA;EACA,cD33Ba;EC43Bb,mBAAA;AAgLR;AA7KM;;;;EACE,eAAA;EACA,uBD54BU;EC64BV,aAAA;AAkLR;AA9KM;;;;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yFAAA;EACA,mCD15BQ;EC25BR,mCAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,qFAAA;EACA,eAAA;EACA,sBAAA;AAmLR;AAjLQ;;;;;;;EAEE,yBAAA;EACA,qBAAA;EACA,WAAA;AAwLV;AArLQ;;;;EACE,0BAAA;AA0LV;AAvLQ;;;;EACE,gBAAA;EACA,wBAAA;EACA,eAAA;AA4LV;AAvLM;;;;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yFAAA;EACA,mCD97BQ;EC+7BR,mCAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,qFAAA;EACA,eAAA;EACA,sBAAA;AA4LR;AA1LQ;;;;;;;EAEE,yBAAA;EACA,qBAAA;EACA,WAAA;AAiMV;AA9LQ;;;;EACE,0BAAA;AAmMV;AAhMQ;;;;EACE,gBAAA;EACA,wBAAA;EACA,eAAA;AAqMV;AAlMQ;;;;;;;EAEE,gBAAA;AAyMV;AApMM;;;;EACE,mBAAA;AAyMR;AAvMQ;;;;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDv9BW;ECw9BX,kBAAA;EACA,wEDjgCG;AC6sCb;AAzMQ;;;;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,wED1gCG;EC2gCH,cDn+BW;ECo+BX,sBAAA;EACA,oLAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,0DAAA;AA8MV;AA5MU;;;;EACE,qBAAA;AAiNZ;AA9MU;;;;EACE,aAAA;EACA,8BDzgCI;EC0gCJ,6CAAA;AAmNZ;;AAvME;EACE,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,mFAAA;AA0MJ;AAvME;EACE,2BAAA;AAyMJ;AAtME;;EAEE,aAAA;AAwMJ;AArME;EACE,gGAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;AAuMJ;AApME;EAAK,0BAAA;AAuMP;AAtME;EAAK,0BAAA;AAyMP;AAxME;EAAK,0BAAA;AA2MP;AA1ME;EAAa,0BAAA;AA6Mf;AA3ME;EACE,kCAAA;EACA,gCAAA;EACA,gDAAA;EACA,qDAAA;EACA,gBAAA;AA6MJ;AA1ME;;EAEE,yBAAA;EACA,qCD/jCY;AC2wChB;AAxME;;;EAGE,+BAAA;EACA,mBAAA;EACA,QAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,oGAAA;EACA,8CAAA;EACA,8CAAA;EACA,sBAAA;EACA,6BAAA;EACA,gCAAA;EACA,sBAAA;EACA,gEAAA;EACA,eAAA;AA0MJ;AAxMI;;;;;EAEE,oCAAA;EACA,gCAAA;EACA,sBAAA;AA6MN;AAzME;EACE,yBAAA;EACA,2BAAA;AA2MJ;AAxME;EACE,2BAAA;EACA,6BAAA;AA0MJ;AAvME;EACE,kBAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;AAyMJ;AAtME;EAAQ,gCAAA;AAyMV;AAxME;EAAQ,mCAAA;AA2MV;AAzME;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AA2MJ;AAxME;EACE,cAAA;EACA,kBAAA;EACA,uCAAA;EACA,mBAAA;EACA,cDhnCiB;ECinCjB,kBAAA;EACA,0BAAA;AA0MJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import 'assets/styles/variables';\n$assets: 'https://assets.foursightonline.com/app';\n\n// ── Expired / Coming-Soon card state ──────────────────────────────────────────\n.dc-locked {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 72px 32px 88px;\n  min-height: 360px;\n  width: 100%;\n  background: linear-gradient(160deg, #fafafa 0%, #fff5f5 100%);\n\n  &__icon-wrap {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background: #fff;\n    border: none;\n    box-shadow: 0 4px 20px rgba(198, 40, 40, 0.15), 0 1px 4px rgba(0,0,0,0.08);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 24px;\n  }\n\n  &__icon {\n    font-size: 30px;\n    color: #e53935;\n  }\n\n  &__title {\n    font-size: 24px;\n    font-weight: 700;\n    color: #212121;\n    margin: 0 0 16px;\n    max-width: 480px;\n    line-height: 1.3;\n  }\n\n  &__badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    padding: 3px 10px;\n    border-radius: 20px;\n    margin-bottom: 16px;\n\n    &--expired {\n      background: linear-gradient(135deg, #e53935, #c62828);\n      color: #fff;\n      box-shadow: 0 3px 10px rgba(198, 40, 40, 0.35);\n    }\n\n    &--upcoming {\n      background: linear-gradient(135deg, #1e88e5, #1565c0);\n      color: #fff;\n      box-shadow: 0 3px 10px rgba(21, 101, 192, 0.35);\n    }\n  }\n\n  &__msg {\n    font-size: 14px;\n    color: #757575;\n    margin: 0;\n    max-width: 360px;\n    line-height: 1.7;\n\n    strong {\n      color: #424242;\n      font-weight: 600;\n    }\n  }\n}\n\n$mq-large-mob: 'only screen and (max-width: 480px)';\n\n\n.media-content {\n  position: relative;\n}\n\n.media-content {\n  position: relative;\n\n  .product__heading {\n    &--activity {\n      margin-bottom: 20px;\n\n      small {\n        font-size: 65%;\n        font-weight: 400;\n      }\n    }\n  }\n}\n\n.fixed-loader {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n\n  i {\n    font-size: 8em !important;\n  }\n}\n\n.iguide-download {\n  width: 100%;\n}\n\n.mr-top-15 {\n  margin-top: 10px;\n}\n\n/* iCheck plugin Square skin, green\n----------------------------------- */\n\n::ng-deep .ibox-content {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n\n  &--bdr {\n    border: 0;\n    padding-inline: 0;\n  }\n\n  .icheckbox_square-green,\n  .iradio_square-green {\n    display: inline-block;\n    *display: inline;\n    vertical-align: middle;\n    margin: 0;\n    padding: 0;\n    width: 22px;\n    height: 22px;\n    background: url('#{$assets}/images/green.png') no-repeat;\n    border: none;\n    cursor: pointer;\n  }\n\n  .icheckbox_square-green {\n    background-position: 0 0;\n  }\n\n  .icheckbox_square-green.hover {\n    background-position: -24px 0;\n  }\n\n  .icheckbox_square-green.checked {\n    background-position: -48px 0;\n  }\n\n  .icheckbox_square-green.disabled {\n    background-position: -72px 0;\n    cursor: default;\n  }\n\n  .icheckbox_square-green.checked.disabled {\n    background-position: -96px 0;\n  }\n\n  .iradio_square-green {\n    background-position: -120px 0;\n  }\n\n  .iradio_square-green.hover {\n    background-position: -144px 0;\n  }\n\n  .iradio_square-green.checked {\n    background-position: -168px 0;\n  }\n\n  .iradio_square-green.disabled {\n    background-position: -192px 0;\n    cursor: default;\n  }\n\n  .iradio_square-green.checked.disabled {\n    background-position: -216px 0;\n  }\n\n  /* HiDPI support */\n  @media (-o-min-device-pixel-ratio: 5/4),\n  (-webkit-min-device-pixel-ratio: 1.25),\n  (min-resolution: 120dpi) {\n\n    .icheckbox_square-green,\n    .iradio_square-green {\n      background-image: url('#{$assets}/images/green@2x.png');\n      -webkit-background-size: 240px 24px;\n      background-size: 240px 24px;\n    }\n  }\n}\n\n.package-form {\n  display: inline-block;\n  width: 50%;\n  padding-right: 40px;\n\n  label,\n  select {\n    width: 100%;\n  }\n\n  label {\n    line-height: 2em;\n    padding: .75rem .75rem .75rem 0 !important;\n    display: inline-block;\n    max-width: 100%;\n    margin-bottom: 5px;\n    font-weight: 700;\n  }\n\n  select {\n    border: 1px solid #ddd;\n    padding: 10px !important;\n    height: 40px;\n    background: #F8F8F8;\n    color: #636363;\n    font-family: 'Museo-300';\n    margin-bottom: 10px;\n  }\n\n  select:focus {\n    outline: none;\n  }\n}\n\n.iguide-download {\n  width: 100%;\n\n  .warning {\n    padding-top: 10px;\n    display: block;\n  }\n}\n\n.mr-top-15 {\n  margin-top: 10px;\n}\n\n::ng-deepul.inputs-list {\n  padding-left: 0;\n  list-style: none;\n}\n\n::ng-deepul.inputs-list input {\n  margin-right: 10px;\n}\n\n::ng-deep#hubspotForm {\n  margin-bottom: 10px;\n}\n\n::ng-deep.hs-error-msgs {\n  display: none !important;\n}\n\n.mark-checkbox {\n  margin-right: 5px;\n}\n\n.ibox {\n  &--bdr {\n    border: 0 !important;\n  }\n}\n\n.loader-container {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n  background: rgba(236, 236, 236, .9);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: block;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  z-index: 9999999999;\n  height: 100vh;\n  margin: 0 auto;\n}\n\n.loader-spin {\n  background-color: hsla(0, 0%, 92.5%, .9);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.loader__inner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n  animation: blink 2s linear infinite;\n  opacity: 0;\n}\n\n#Path_130 {\n  animation: blink 2s linear infinite;\n  animation-delay: .5s;\n  opacity: 0;\n}\n\n#Path_132 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1s;\n  opacity: 0;\n}\n\n#Path_131 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1.5s;\n  opacity: 0;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.single-box-nav {\n  .text-center {\n    span {\n      &.scroll-btn {\n        a {\n          &:after {\n            width: unset;\n          }\n        }\n      }\n    }\n  }\n}\n\n.img {\n  &--xtrahyt {\n    min-height: 420px;\n  }\n}\n\n.image-imitation {\n  --flexGap: 45px;\n\n  .audio-card {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &__player {\n\n      audio {\n        height: var(--flexGap);\n      }\n    }\n\n    &__vol {\n      width: var(--flexGap);\n      height: var(--flexGap);\n      background-color: #eee;\n      border-radius: 50%;\n      border: 0;\n      cursor: pointer;\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      align-items: center;\n      padding-inline: 10px;\n      margin-left: 10px;\n    }\n\n    &__ftrtextneg {\n      border-radius: 30px;\n      outline: none;\n      box-shadow: none;\n      height: 45px;\n      margin-left: 10px;\n      width: 100px;\n      border: 0px;\n\n      .fa {\n        margin-right: 8px;\n      }\n    }\n\n    &__ftrauth {\n      height: 45px;\n      overflow: hidden;\n      width: 45px;\n      margin-right: 10px;\n\n      img {\n        border-radius: 50%;\n      }\n    }\n  }\n}\n\n::ng-deep .coach-slider {\n\n  .page-heading {\n    @media #{$tablet} {\n      margin-bottom: 0 !important;\n    }\n  }\n\n  .ibox {\n    position: relative;\n\n    &__close {\n      position: absolute;\n      right: 11px;\n      z-index: 9;\n      top: 20px;\n\n      @media #{$tablet} {\n        right: 35px;\n      }\n\n      a {\n        border-radius: 50%;\n        border: 1px solid #CFDBE2;\n        padding: 4px 8px;\n      }\n    }\n\n    &-footer {\n      // padding: 10px 0px;\n\n      @media #{$tablet} and (orientation: landscape) {\n        display: flex;\n        // max-width: 83%;\n        margin: 0 auto;\n\n        .next-link {\n          padding-right: 60px;\n        }\n      }\n\n      .single-box-nav {\n        display: flex;\n        justify-content: space-between;\n\n        a {\n          font-size: 14px !important;\n        }\n\n      }\n\n      .col-xs-3 {\n        width: 50%;\n        padding-left: 5px;\n        padding-right: 5px;\n      }\n    }\n\n    &-content {\n\n      .single-card-link {\n        padding: 10px 0;\n      }\n\n      hr {\n        display: none;\n      }\n\n      br {\n        display: none;\n      }\n\n      .card-description {\n        padding-bottom: 25px;\n\n        p {\n          margin: 0;\n          font-size: 14px;\n          color: $body-content-color;\n        }\n\n      }\n    }\n\n  }\n\n  &-footer {\n    padding: 10px 0px;\n\n    .single-box-nav {\n      display: flex;\n      justify-content: space-between;\n\n      a {\n        font-size: 14px !important;\n      }\n\n    }\n\n    .image-imitation {\n      box-shadow: none;\n\n\n      .audio-card {\n\n        audio {\n          max-width: 100%;\n        }\n\n        @media #{$mq-large-mob} {\n          transform: scale(0.8);\n\n          &__vol,\n          &__ftrtextneg {\n            display: none;\n          }\n\n          audio::-webkit-media-controls-volume-slider,\n          audio::-webkit-media-controls-mute-button,\n          audio::-webkit-media-controls-volume-slider-container {\n            display: block;\n          }\n\n        }\n\n        &__ftrauth {\n          height: 36px;\n          width: 36px;\n          margin-right: 5px;\n        }\n\n        &__vol {\n          margin-left: 10px;\n          height: 26px;\n          width: 26px;\n\n        }\n\n        &__ftrtextneg {\n          width: 55px;\n          height: 26px;\n\n          span {\n            font-size: 10px;\n\n            i {\n              margin-right: 4px;\n            }\n          }\n        }\n      }\n\n    }\n  }\n\n  &-content {\n\n    .single-card-link {\n      padding: 10px 0;\n    }\n\n    hr {\n      display: none;\n    }\n\n    br {\n      display: none;\n    }\n\n    .card-description {\n      padding-bottom: 25px;\n\n      p {\n        margin: 0;\n        font-size: 14px;\n        color: #676A6C;\n      }\n\n    }\n  }\n\n}\n\n.media-content {\n\n  &__head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-right: 10px;\n  }\n\n  &__audio {\n    align-items: flex-start;\n    min-height: auto;\n    padding-bottom: 15px;\n  }\n\n  .image-imitation {\n    box-shadow: none;\n\n\n    .audio-card {\n\n      audio {\n        max-width: 100%;\n      }\n\n      @media #{$mq-large-mob} {\n        transform: scale(0.8);\n\n        &__vol,\n        &__ftrtextneg {\n          display: none;\n        }\n\n        audio::-webkit-media-controls-volume-slider,\n        audio::-webkit-media-controls-mute-button,\n        audio::-webkit-media-controls-volume-slider-container {\n          display: block;\n        }\n\n      }\n\n      &__ftrauth {\n        height: 36px;\n        width: 36px;\n        margin-right: 5px;\n      }\n\n      &__vol {\n        margin-left: 10px;\n        height: 26px;\n        width: 26px;\n\n      }\n\n      &__ftrtextneg {\n        width: 55px;\n        height: 26px;\n\n        span {\n          font-size: 10px;\n\n          i {\n            margin-right: 4px;\n          }\n        }\n      }\n    }\n\n  }\n}\n\n.white-bg {\n\n  &.page-heading {\n\n    &.challenge-coach {\n      margin-top: -20px;\n      margin-bottom: 20px;\n\n      .breadcrumb {\n        font-size: 12px;\n      }\n\n      .button-wrapper-flex-right {\n        width: 10%;\n      }\n\n      .col-lg-10 {\n        width: 90%;\n      }\n    }\n  }\n}\n\n.dc-single {\n\n  &__inner {\n\n    .ibox {\n\n      &-content {\n\n        .media-content {\n\n          h2 {\n\n            small {\n              font-size: 65%;\n              line-height: 1;\n              font-weight: 400;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  hr {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    border: 0;\n    border-top: 1px solid #eeeeee;\n  }\n}\n\n.product-detail {\n\n  .ibox-content {\n\n    .f-flex {\n\n      .media-content {\n        @media (max-width: 1440px) {\n          width: 50%;\n        }\n\n        @media (min-width: 769px) and (max-width: 991px),\n        (max-width: 640px) {\n          width: 100%;\n          padding-inline: 15px;\n        }\n\n        &+.media-content {\n          @media (max-width: 1440px) {\n            padding-right: 15px;\n          }\n        }\n      }\n    }\n  }\n\n  .ibox-footer {\n\n    .single-box-nav {\n\n      .text-left {\n\n        a {\n\n          &:before {\n\n            @media (min-width: 769px) and (max-width: 991px),\n            (max-width: 640px) {\n              font-size: 20px;\n              left: -24px;\n            }\n          }\n        }\n\n        @media (min-width: 769px) and (max-width: 991px),\n        (max-width: 640px) {\n          padding-left: 0;\n        }\n      }\n\n      .text-center {\n\n        span {\n\n          &.scroll-btn {\n\n            a {\n\n              &:after {\n\n                @media (min-width: 769px) and (max-width: 991px),\n                (max-width: 640px) {\n                  height: 20px;\n                  bottom: -19px;\n                  width: 100% !important;\n                  border: none;\n                  background: #666;\n                  clip-path: polygon(102% 0%, -2% 0, 50% 100%);\n                  left: 0;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .text-right {\n\n        a {\n\n          &:after {\n\n            @media (min-width: 769px) and (max-width: 991px),\n            (max-width: 640px) {\n              font-size: 20px;\n              right: -24px;\n            }\n          }\n        }\n\n        @media (min-width: 769px) and (max-width: 991px),\n        (max-width: 640px) {\n          padding-right: 0;\n        }\n      }\n    }\n  }\n}\n\n.mark-btn {\n  &>div {\n    border: 1px solid $color-grey-1;\n    border-bottom: 0;\n    font-weight: 700;\n\n    input[type=checkbox] {\n      height: auto;\n      width: auto;\n      opacity: 1;\n      position: static !important;\n      accent-color: green;\n    }\n  }\n\n// ═══════════════════════════════════════════════════════════════════\n// Card Content Cleanup — Left content area refinement\n// ═══════════════════════════════════════════════════════════════════\n\n.dc-single .ibox-content .media-content,\n.dc-single .media-content {\n  // ─── Card Title ───\n  .single-card-link {\n    font-family: $muso-700, $font-stack !important;\n    font-size: 22px !important;\n    line-height: 1.3 !important;\n    color: $color-neutral-dark !important;\n    margin: 0 0 14px !important;\n    padding: 0 30px 0 0 !important;\n    letter-spacing: -0.01em;\n\n    .pull-right.grey-link {\n      font-size: 18px;\n      color: $color-neutral-mid;\n      transition: color 0.15s ease;\n\n      &:hover {\n        color: $clarify-color;\n      }\n    }\n  }\n\n  // ─── Activity / Length metadata ───\n  .m-t-md .product-main-price,\n  .product-main-price {\n    font-size: 13px !important;\n    line-height: 1.6 !important;\n    color: $body-content-color !important;\n    margin: 0 0 18px !important;\n    padding: 12px 16px !important;\n    background: #f7f8fa !important;\n    border-left: 3px solid $clarify-color !important;\n    border-radius: 4px !important;\n    font-family: $font-stack !important;\n    font-weight: 400 !important;\n\n    small {\n      font-size: 13px !important;\n      font-weight: 500 !important;\n      color: $body-content-color !important;\n      display: inline-block;\n      line-height: 1.8;\n    }\n  }\n\n  hr {\n    display: block !important;\n    border: 0 !important;\n    border-top: 1px solid $color-grey-1 !important;\n    margin: 18px 0 !important;\n  }\n\n    // ─── API-provided HTML body content (innerHTML) ───\n    .card-description {\n      font-size: 14px !important;\n      line-height: 1.65 !important;\n      color: $body-content-color !important;\n      font-family: $font-stack !important;\n      padding: 0 !important;\n    }\n\n    // ─── Download / CTA buttons ───\n    .iguide-download,\n    .package-form {\n      margin-top: 18px;\n\n      > span {\n        display: inline-block;\n        font-size: 13px;\n        color: $body-content-color;\n        margin-bottom: 10px;\n      }\n\n      .warning {\n        font-size: 13px;\n        color: $implement-color;\n        margin: 8px 0;\n      }\n\n      // Certificate download button\n      .btn.btn-primary {\n        display: inline-flex;\n        align-items: center;\n        gap: 8px;\n        padding: 9px 18px;\n        font-size: 13px;\n        font-weight: 600;\n        font-family: $muso-500, $font-stack;\n        background-color: $develop-color;\n        border: 1px solid $develop-color;\n        color: #fff;\n        border-radius: 6px;\n        text-decoration: none;\n        transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.1s ease;\n        cursor: pointer;\n        letter-spacing: 0.02em;\n\n        &:hover,\n        &:focus {\n          background-color: darken($develop-color, 6%);\n          border-color: darken($develop-color, 6%);\n          color: #fff;\n        }\n\n        &:active {\n          transform: translateY(1px);\n        }\n\n        &::before {\n          content: '\\f019'; // fa-download\n          font-family: FontAwesome;\n          font-size: 12px;\n        }\n      }\n\n      // Interpretive Guide download buttons (f-btn)\n      .f-btn {\n        display: inline-flex;\n        align-items: center;\n        gap: 8px;\n        padding: 9px 18px;\n        font-size: 13px;\n        font-weight: 600;\n        font-family: $muso-500, $font-stack;\n        background-color: $develop-color;\n        border: 1px solid $develop-color;\n        color: #fff;\n        border-radius: 6px;\n        text-decoration: none;\n        transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.1s ease;\n        cursor: pointer;\n        letter-spacing: 0.02em;\n\n        &:hover,\n        &:focus {\n          background-color: darken($develop-color, 6%);\n          border-color: darken($develop-color, 6%);\n          color: #fff;\n        }\n\n        &:active {\n          transform: translateY(1px);\n        }\n\n        &::before {\n          content: '\\f019';\n          font-family: FontAwesome;\n          font-size: 12px;\n        }\n\n        & + .f-btn,\n        &.f-m-top-15 {\n          margin-top: 10px;\n        }\n      }\n\n      // ─── Form controls (language select) ───\n      .assessment {\n        margin-bottom: 14px;\n\n        label {\n          display: block;\n          font-size: 12px;\n          font-weight: 600;\n          text-transform: uppercase;\n          letter-spacing: 0.05em;\n          color: $color-neutral-dark;\n          margin-bottom: 6px;\n          font-family: $font-stack;\n        }\n\n        select {\n          display: block;\n          width: 100%;\n          max-width: 320px;\n          padding: 9px 36px 9px 12px;\n          font-size: 14px;\n          font-family: $font-stack;\n          color: $color-neutral-dark;\n          background-color: #fff;\n          background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath fill='%236d6e71' d='M6 8.5L1.5 4h9z'/%3E%3C/svg%3E\");\n          background-repeat: no-repeat;\n          background-position: right 12px center;\n          background-size: 12px;\n          border: 1px solid $color-grey-1;\n          border-radius: 6px;\n          cursor: pointer;\n          appearance: none;\n          -webkit-appearance: none;\n          transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n          &:hover {\n            border-color: darken($color-grey-1, 8%);\n          }\n\n          &:focus {\n            outline: none;\n            border-color: $clarify-color;\n            box-shadow: 0 0 0 3px rgba($clarify-color, 0.15);\n          }\n        }\n      }\n    }\n  }\n}\n\n// ═══════════════════════════════════════════════════════════════════\n// innerHTML body content — use ::ng-deep to pierce view encapsulation\n// ═══════════════════════════════════════════════════════════════════\n:host ::ng-deep .dc-single .card-description {\n  p {\n    margin: 0 0 14px !important;\n    font-size: 14px !important;\n    line-height: 1.65 !important;\n    color: $body-content-color !important;\n    font-family: $font-stack !important;\n  }\n\n  p:last-child {\n    margin-bottom: 0 !important;\n  }\n\n  p:empty,\n  p > br:only-child {\n    display: none;\n  }\n\n  h1, h2, h3, h4, h5, h6 {\n    font-family: $muso-700, $font-stack !important;\n    color: $color-neutral-dark !important;\n    margin: 22px 0 10px !important;\n    line-height: 1.35 !important;\n    font-weight: 700 !important;\n  }\n\n  h1 { font-size: 20px !important; }\n  h2 { font-size: 18px !important; }\n  h3 { font-size: 16px !important; }\n  h4, h5, h6 { font-size: 14px !important; }\n\n  a {\n    color: $clarify-color !important;\n    text-decoration: none !important;\n    border-bottom: 1px solid rgba($clarify-color, 0.35);\n    transition: border-color 0.15s ease, color 0.15s ease;\n    font-weight: 500;\n  }\n\n  a:hover,\n  a:focus {\n    color: darken($clarify-color, 8%) !important;\n    border-bottom-color: $clarify-color;\n  }\n\n  // Buttons embedded in innerHTML content (e.g. Download Presenter Guide)\n  a.btn,\n  a[class*=\"btn-\"],\n  button {\n    display: inline-flex !important;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 20px !important;\n    font-size: 13px !important;\n    font-weight: 600 !important;\n    font-family: $muso-500, $font-stack !important;\n    background-color: $develop-color !important;\n    border: 1px solid $develop-color !important;\n    color: #fff !important;\n    border-radius: 6px !important;\n    text-decoration: none !important;\n    letter-spacing: 0.02em;\n    transition: background-color 0.15s ease, border-color 0.15s ease;\n    margin-top: 6px;\n\n    &:hover,\n    &:focus {\n      background-color: darken($develop-color, 6%) !important;\n      border-color: darken($develop-color, 6%) !important;\n      color: #fff !important;\n    }\n  }\n\n  strong, b {\n    color: $color-neutral-dark !important;\n    font-weight: 600 !important;\n  }\n\n  ul, ol {\n    margin: 0 0 14px !important;\n    padding-left: 22px !important;\n  }\n\n  ul li, ol li {\n    margin-bottom: 6px;\n    font-size: 14px !important;\n    line-height: 1.65 !important;\n    color: $body-content-color !important;\n  }\n\n  ul li { list-style-type: disc !important; }\n  ol li { list-style-type: decimal !important; }\n\n  img {\n    max-width: 100%;\n    height: auto;\n    border-radius: 6px;\n    margin: 10px 0;\n  }\n\n  blockquote {\n    margin: 14px 0;\n    padding: 10px 16px;\n    border-left: 3px solid $ideate-color;\n    background: #fffaf4;\n    color: $body-content-color;\n    font-style: italic;\n    border-radius: 0 4px 4px 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
